import FrontOurTeamCards from "@/Components/Front/Blocks/FrontOurTeamCards";
import ServiceDescription from "@/Components/Front/Blocks/ServiceDescription";
import ServicesHero from "@/Components/Front/Blocks/ServicesHero";
import WebpImage from "@/Components/Front/Blocks/WebpImage";
import WhatWeOffer from "@/Components/Front/Blocks/WhatWeOffer";
import FrontText from "@/Components/Front/FrontText";
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { useTranslation } from "react-i18next";
import ServicesCta from "@/Components/Front/Blocks/ServicesCta";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";

const LeaseRenegotiations = ({ seo, agents }) => {
    const { t, i18n } = useTranslation();

    return (
        <FrontLayout breadcrumbs={[
            { title: t('breadcrumbs.services'), current: false, href: resolveLocaleRoute('front.services', null, i18n.resolvedLanguage) },
            { title: t('breadcrumbs.leaseRenegotiations'), current: true },
        ]}>
            <FrontSeoMetaTags seo={seo}/>
            <section>
                <ServicesHero icon={'/storage/icons/service-package-icon.svg'} title={t('services.leaseRenegotiationsHeading')} />
                <ServiceDescription contentKey={'services.leaseRenegotiationsDescription'} lng={i18n.resolvedLanguage}>
                    <WebpImage
                        className='rounded-10 mt-5'
                        sources={[
                            {
                                width: 768,
                                path: '/storage/images/warehouse-lease-renegotiations-size-530',
                                mime: '/jpg'
                            },
                            {
                                width: 1,
                                path: '/storage/images/warehouse-lease-renegotiations',
                                mime: 'jpg'
                            }
                        ]}
                        alt={t('services.leaseRenegotiationsHeading')}
                        fallback={`/storage/images/warehouse-lease-renegotiations.jpg`}
                        seo={{
                            width: 520,
                            height: 287
                        }}
                    />
                </ServiceDescription>
            </section>
            <section>
                <Container>
                    <Row>
                        <Column>
                            <FrontText className="text-center mb-10 font-domine font-bold text-dark-blue" textSize={'38/43-m-24/27'}>
                                <h2>{t('services.leaseRenegotiationsWhatWeOfferHeading')}</h2>
                            </FrontText>
                        </Column>
                    </Row>
                    <WhatWeOffer itemsKey={`services.leaseRenegotiationsWhatWeOffer`} />
                </Container>
            </section>

            <section>
                <ServicesCta
                    headingKey={`services.leaseRenegotiationsCtaHeading`}
                    buttonLinkKey={`services.leaseRenegotiationsCtaLink`}
                    buttonTextKey={`services.leaseRenegotiationsCtaLinkText`}
                />
            </section>

            <section className="xl:mb-c120 lg:mb-25 md:mb-20 mb-15">
                <FrontOurTeamCards agents={agents}/>
            </section>
        </FrontLayout>
    )
}

export default LeaseRenegotiations;